import {
  Button,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  BLUEMONEDDBUTTONS,
  GRAY_DARKER,
  WHITE,
} from "../../../constants/colors";
import { JWTToken } from "../../../routes/privateRoute";
import ExtratoApi from "../../../services/ExtratoAPI";
import jwt_decode from "jwt-decode";
import { dadosDoToken } from "../../../defaultFunctions/token";
import moment from "moment";
import DateDropdown from "../defaultComponents/dateDropdown";
import { dateForAPI } from "../../../constants/dataFormat";
import BarChart from "../../../defaultComponents/barchart";
import { SaldoBandeiras } from "../../../interfaces/defaultInterfaces";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../atoms/customColors";

export default function TablesComponent({dateF, setDateF, dateI, setDateI}: any) {
  const token = window.localStorage.getItem("token");
  const jwtToken = dadosDoToken(token) as JWTToken;
  const id = Number(jwtToken.idCliente);
  const fontItems = "clamp(12px, 0.8vw, 15px)"

  const [selected, setSelected] = useState("h");
  const [dados, setDados] = useState([
    {
      aprovadas: 0,
      canceladas: 0,
      pendentes: 0,
      vendasCredito: 0,
      vendasDebito: 0,
      vendasBoleto: 0,
      vendasPIX: 0,
      totalVendas: 0,
    },
  ]);
  const [disable, setDisable] = useState(false);
  const [bandeirasSaldo, setBandeirasSaldo] = useState(Array<SaldoBandeiras>);
  const colors = useRecoilState(customColors)[0];

  const percentCredito = (dados[0].vendasCredito / dados[0].totalVendas) * 100;
  const percentDebido = (dados[0].vendasDebito / dados[0].totalVendas) * 100;
  const percentBoleto = (dados[0].vendasBoleto / dados[0].totalVendas) * 100;
  const percentPix = (dados[0].vendasPIX / dados[0].totalVendas) * 100;

  async function getDados() {
    try {
      setDisable(true)
      const response = await ExtratoApi.getSaldoVendas(dateI, dateF, id);
      setDados(
        response.data != ""
          ? response.data
          : [
              {
                aprovadas: 0,
                canceladas: 0,
                pendentes: 0,
                vendasCredito: 0,
                vendasDebito: 0,
                vendasBoleto: 0,
                vendasPIX: 0,
                totalVendas: 0,
              },
            ]
      );
      setDisable(false)
    } catch (error) {
      console.log(error);
      setDisable(false)
    }
  }

  useEffect(() => {
    getDados();
    getBandeirasSales();
  }, [dateI, dateF]);

  function filterToday() {
    setDateI(moment(Date()).startOf("day").format(dateForAPI));
    setDateF(moment(Date()).endOf("day").format(dateForAPI));
    setSelected("h");
  }

  function filterYesterday() {
    setDateI(moment(Date()).add(-1, "day").startOf("day").format(dateForAPI));
    setDateF(moment(Date()).add(-1, "day").endOf("day").format(dateForAPI));
    setSelected("o");
  }

  function filterLast7Days() {
    setDateI(moment(Date()).add(-7, "day").startOf("day").format(dateForAPI));
    setDateF(moment(Date()).endOf("day").format(dateForAPI));
    setSelected("7d");
  }

  function filterLast15Days() {
    setDateI(moment(Date()).add(-15, "day").startOf("day").format(dateForAPI));
    setDateF(moment(Date()).endOf("day").format(dateForAPI));
    setSelected("15d");
  }

  function filterLast3Months() {
    setDateI(moment(Date()).add(-3, "month").startOf("day").format(dateForAPI));
    setDateF(moment(Date()).endOf("day").format(dateForAPI));
    setSelected("3m");
  }

  async function getBandeirasSales() {
    try {
      const response = await ExtratoApi.getSaldoBandeira(dateI, dateF, id);
      setBandeirasSaldo(response);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Flex
      w={"100%"}
      h={"100%"}
      justifyContent={"space-evenly"}
      flexDirection={"column"}
      alignItems="center"
    >
      <Text color={colors.BLUEMONEDDBUTTONS} fontWeight={"600"} fontSize={"clamp(13px, 1vw, 18px)"}>
        ACOMPANHE AS VENDAS DOS ÚLTIMOS PERÍODOS
      </Text>
      <Flex mb={1}>
        <Button
          isDisabled={disable}
          isLoading={(disable && selected === "h")}
          bg={selected === "h" ? "#E2E8F0" : "none"}
          color={colors.GRAY_DARKER}
          mx="2px"
          onClick={() => filterToday()}
          fontSize={fontItems}
          h={"30px"}
          // w={"clamp(36px, 3vw, 56px)"}
        >
          Hoje
        </Button>
        <Button
         isDisabled={disable}
         isLoading={(disable && selected === "o")}
          bg={selected === "o" ? "#E2E8F0" : "none"}
          color={colors.GRAY_DARKER}
          mx="2px"
          onClick={() => filterYesterday()}
          fontSize={fontItems}
          h={"30px"}
          // w={"40px"}
        >
          Ontem
        </Button>
        <Button
         isDisabled={disable}
         isLoading={(disable && selected === "7d")}
          bg={selected === "7d" ? "#E2E8F0" : "none"}
          color={colors.GRAY_DARKER}
          mx="2px"
          onClick={() => filterLast7Days()}
          fontSize={fontItems}
          h={"30px"}
          // w={"80px"}
        >
          Últimos 7 Dias
        </Button>
        <Button
         isDisabled={disable}
         isLoading={(disable && selected === "15d")}
          bg={selected === "15d" ? "#E2E8F0" : "none"}
          color={colors.GRAY_DARKER}
          mx="2px"
          onClick={() => filterLast15Days()}
          fontSize={fontItems}
          h={"30px"}
          // w={"80px"}
        >
          Últimos 15 Dias
        </Button>
        <Button
         isDisabled={disable}
         isLoading={(disable && selected === "3m")}
          bg={selected === "3m" ? "#E2E8F0" : "none"}
          color={colors.GRAY_DARKER}
          mx="2px"
          onClick={() => filterLast3Months()}
          fontSize={fontItems}
          h={"30px"}
          // w={"80px"}
        >
          Últimos 3 Meses
        </Button>
        <DateDropdown
          selected={selected}
          setSelected={setSelected}
          setDateF={setDateF}
          setDateI={setDateI}
          dateF={dateF}
          dateI={dateI}
        />
      </Flex>
      {/* wrap + larguras por breakpoint: em 4:3 / janela estreita os três
          blocos (resumo, percentuais e gráfico) empilham em vez de espremer. */}
      <Flex
        w={"100%"}
        justifyContent="space-evenly"
        alignItems="center"
        flexWrap="wrap"
        gap={{ base: 3, md: 2 }}
        mt={"clamp(8px, 1vw, 20px)"}
      >
        <TableContainer borderRadius="8px" w={{ base: "100%", md: "30%" }} minW={"250px"}>
          <Table variant="simple" size="sm" overflow="scroll">
            <Thead position="sticky" top="0">
              <Tr>
                <Th
                  textAlign={"center"}
                  borderRadius={"8px 8px 8px 8px"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                  fontSize={fontItems}
                >
                  Resumo das vendas
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td borderRadius={"9px"} textAlign={"center"} bg={"#f9f9f9"}>
                  <Flex
                    w={"100%"}
                    h={"100%"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Flex
                      w="50%"
                      h="100%"
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                    >
                      <Text
                        color={colors.BLUEMONEDDBUTTONS}
                        fontWeight={"bold"}
                        fontSize={fontItems}
                      >
                        APROVADAS
                      </Text>
                    </Flex>
                    <Flex
                      w="50%"
                      h="100%"
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                      pl={"10px"}
                    >
                      {/* <Text color={GRAY_DARKER} fontSize={fontItems}>
                        {dados[0] &&
                          dados[0].aprovadas.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                      </Text> */}
                      <Flex color={colors.GRAY_DARKER} fontSize={fontItems} width={"100%"} justifyContent="space-between" alignItems={"center"}><Text>R$</Text><Text>{dados[0] &&
                          dados[0].aprovadas.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          }).replace("R$", "")}</Text></Flex>
                    </Flex>
                  </Flex>
                </Td>
              </Tr>
              <Tr>
                <Td borderRadius={"9px"} textAlign={"center"} bg={"#f9f9f9"}>
                  <Flex
                    w={"100%"}
                    h={"100%"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Flex
                      w="50%"
                      h="100%"
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                    >
                      <Text
                        color={colors.BLUEMONEDDBUTTONS}
                        fontWeight={"bold"}
                        fontSize={fontItems}
                      >
                        CANCELADAS
                      </Text>
                    </Flex>
                    <Flex
                      w="50%"
                      h="100%"
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                      pl={"10px"}
                    >
                      {/* <Text color={GRAY_DARKER} fontSize={fontItems}>
                        {dados[0] &&
                          dados[0].canceladas.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                      </Text> */}
                      <Flex color={colors.GRAY_DARKER} fontSize={fontItems} width={"100%"} justifyContent="space-between" alignItems={"center"}><Text>R$</Text><Text>{dados[0] &&
                          dados[0].canceladas.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          }).replace("R$", "")}</Text></Flex>
                    </Flex>
                  </Flex>
                </Td>
              </Tr>
              <Tr>
                <Td borderRadius={"9px"} textAlign={"center"} bg={"#f9f9f9"}>
                  <Flex
                    w={"100%"}
                    h={"100%"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Flex
                      w="50%"
                      h="100%"
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                    >
                      <Text
                        color={colors.BLUEMONEDDBUTTONS}
                        fontWeight={"bold"}
                        fontSize={fontItems}
                      >
                        PENDENTES
                      </Text>
                    </Flex>
                    <Flex
                      w="50%"
                      h="100%"
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                      pl={"10px"}
                    >
                      {/* <Text color={GRAY_DARKER} fontSize={fontItems}>
                        {dados[0] &&
                          dados[0].pendentes.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                      </Text> */}
                      <Flex color={colors.GRAY_DARKER} fontSize={fontItems} width={"100%"} justifyContent="space-between" alignItems={"center"}><Text>R$</Text><Text>{dados[0] &&
                          dados[0].pendentes.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          }).replace("R$", "")}</Text></Flex>
                    </Flex>
                  </Flex>
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
        <Flex
          w={{ base: "100%", md: "22%" }}
          minW={"200px"}
          h={"100%"}
          borderRadius={"8px"}
          flexDir={"column"}
          fontSize={"clamp(10px, 0.6vw, 13px)"}
          bgColor={"#f9f9f9"}
          p={"10px"}
        >
          <Flex
            h={"50%"}
            w={"100%"}
            justifyContent="space-evenly"
            alignItems="center"
          >
            <Flex
              justifyContent="center"
              alignItems="center"
              flexDir={"column"}
              w={"50%"}
            >
              <Flex
                w={"clamp(36px, 3vw, 56px)"}
                h={"clamp(36px, 3vw, 56px)"}
                borderRadius={"50%"}
                bg={colors.BLUEMONEDDBUTTONS}
                justifyContent="center"
                alignItems="center"
                color={"white"}
              >
                {percentCredito > 0 ? percentCredito.toFixed(2) : 0}%
              </Flex>
              <Text fontWeight={"bold"} color={colors.BLUEMONEDDBUTTONS}>
                CRÉDITO
              </Text>
            </Flex>
            <Flex
              justifyContent="center"
              alignItems="center"
              flexDir={"column"}
              w={"50%"}
            >
              <Flex
                w={"clamp(36px, 3vw, 56px)"}
                h={"clamp(36px, 3vw, 56px)"}
                borderRadius={"50%"}
                bg={colors.BLUEMONEDDBUTTONS}
                justifyContent="center"
                alignItems="center"
                color={"white"}
              >
                {percentDebido > 0 ? percentDebido.toFixed(2) : 0}%
              </Flex>
              <Text fontWeight={"bold"} color={colors.BLUEMONEDDBUTTONS}>
                DÉBITO
              </Text>
            </Flex>
          </Flex>
          <Flex
            h={"50%"}
            w={"100%"}
            justifyContent="space-evenly"
            alignItems="center"
          >
            <Flex
              justifyContent="center"
              alignItems="center"
              flexDir={"column"}
              w={"50%"}
            >
              <Flex
                w={"clamp(36px, 3vw, 56px)"}
                h={"clamp(36px, 3vw, 56px)"}
                borderRadius={"50%"}
                bg={colors.BLUEMONEDDBUTTONS}
                justifyContent="center"
                alignItems="center"
                color={"white"}
              >
                {percentBoleto > 0 ? percentBoleto.toFixed(2) : 0}%
              </Flex>
              <Text fontWeight={"bold"} color={colors.BLUEMONEDDBUTTONS}>
                BOLETO
              </Text>
            </Flex>
            <Flex
              justifyContent="center"
              alignItems="center"
              flexDir={"column"}
              w={"50%"}
            >
              <Flex
                w={"clamp(36px, 3vw, 56px)"}
                h={"clamp(36px, 3vw, 56px)"}
                borderRadius={"50%"}
                bg={colors.BLUEMONEDDBUTTONS}
                justifyContent="center"
                alignItems="center"
                color={"white"}
              >
                {percentPix > 0 ? percentPix.toFixed(2) : 0}%
              </Flex>
              <Text fontWeight={"bold"} color={colors.BLUEMONEDDBUTTONS}>
                PIX
              </Text>
            </Flex>
          </Flex>
        </Flex>

        <Flex
          w={{ base: "100%", md: "40%" }}
          minW={"250px"}
          maxH={"120px"}
          justifyContent="center"
          alignItems={"center"}
        >
          <BarChart labels={bandeirasSaldo} />
        </Flex>
      </Flex>
    </Flex>
  );
}
